const HOSTS = ["images.unsplash.com", "images.pexels.com"];

const isOptimisable = (url) => {
  try {
    return HOSTS.includes(new URL(url).hostname);
  } catch {
    return false;
  }
};

export const img = (url, width, quality = 70) => {
  if (!url || !isOptimisable(url)) return url;
  const u = new URL(url);
  if (u.hostname === "images.unsplash.com") {
    u.searchParams.set("fm", "webp");
    u.searchParams.set("q", String(quality));
    u.searchParams.set("w", String(width));
    u.searchParams.set("auto", "format");
  } else {
    u.searchParams.set("auto", "compress");
    u.searchParams.set("w", String(width));
  }
  return u.toString();
};

export const srcSet = (url, widths) =>
  !url || !isOptimisable(url) ? undefined : widths.map((w) => `${img(url, w)} ${w}w`).join(", ");
